import { LOGGED_IN, SET_AUTH_TOKEN } from './action-types';

const initialState = {
  isLoggedIn: false,
  access_token: ''
};

const loginReducer = (state = initialState, action) => {
  if (action.type === LOGGED_IN) {
    return {
      ...state,
      isLoggedIn: action.payload
    };
  }

  if (action.type === SET_AUTH_TOKEN) {
    return {
      ...state,
      access_token: action.payload
    };
  }

  return state;
};

export default loginReducer;
